import React, { ReactNode } from "react"
import { Box } from "@chakra-ui/react"

type Props = {
  children: ReactNode
}

const ModalContentWrapper = ({ children }: Props) => <Box pt={2} pb={6}>{children}</Box>

export default ModalContentWrapper
